import { recordMapper } from "./record";

export const upsertRecordMapper = recordMapper;
